import React from 'react';
import Route from 'found/lib/Route';
import { Loader } from '../components/Elements';
import { graphql } from 'react-relay';
import ContractTemplateContainer from '../components/Document/Template/Contract/ContractTemplateContainer';
import FormTemplateContainer from '../components/Document/Template/Form/FormTemplateContainer';
import MpTemplateContainer from '../components/Document/Template/MusicPlanner/MpTemplateContainer';
import MpTemplatePlaylistContainer from '../components/Document/Template/MusicPlanner/MpTemplatePlaylistContainer';

const TemplateRoutes = (
  <Route path='templates'>
    <Route
      path='c/:template_id/:action?'
      prepareVariables={params => ({
        ...params,
        id: params.template_id
      })}
      Component={ContractTemplateContainer}
      query={graphql`
        query TemplateRoutes_ContractTemplate_Query($id: ID!) {
          node(id: $id) {
            ...ContractTemplateContainer_node
          }
          viewer {
            ...ContractTemplateContainer_viewer
          }
        }
      `}
      render={({ props }) =>
        (props ? <ContractTemplateContainer {...props} /> : <Loader />)}
    />
    <Route
      path='f/:template_id/:action?'
      prepareVariables={params => ({
        ...params,
        id: params.template_id
      })}
      Component={FormTemplateContainer}
      query={graphql`
        query TemplateRoutes_FormTemplate_Query($id: ID!) {
          node(id: $id) {
            ...FormTemplateContainer_node
          }
          viewer {
            ...FormTemplateContainer_viewer
          }
        }
      `}
      render={({ props }) =>
        (props ? <FormTemplateContainer {...props} /> : <Loader />)}
    />
    <Route
      path='m/:template_id/:action?'
      prepareVariables={params => ({
        ...params,
        id: params.template_id
      })}
      Component={MpTemplateContainer}
      query={graphql`
        query TemplateRoutes_MpTemplate_Query($id: ID!) {
          node(id: $id) {
            ...MpTemplateContainer_node
          }
          viewer {
            ...MpTemplateContainer_viewer
          }
        }
      `}
      render={({ props }) =>
        (props ? <MpTemplateContainer {...props} /> : <Loader />)}
    >
      <Route
        path='playlist/:playlist_id'
        Component={MpTemplatePlaylistContainer}
        query={graphql`
          query TemplateRoutes_MpTemplatePlaylist_Query($playlist_id :ID!) {
            node(id: $playlist_id) {
              ...MpTemplatePlaylistContainer_node @arguments(id: $playlist_id)
            }
            viewer {
              ...MpTemplatePlaylistContainer_viewer
            }
          }
        `}
        render={({ props }) => (props ? <MpTemplatePlaylistContainer {...props} /> : <Loader />)}
      />
    </Route>
  </Route>
);

export default TemplateRoutes;



// WEBPACK FOOTER //
// ./webpack/routes/TemplateRoutes.js